import React from 'react'
import { Box, Typography } from '@mui/material'

import GoogleIcon from '../../../../components/icon/GoogleIcon'
import { REFUND_APPROVAL_TEXT } from '../../../constants/refundApprovalText'
import {
  UI_COLOR_BORDER_INFO_SOFT,
  UI_COLOR_DANGER_OUTLINE,
  UI_COLOR_DANGER_SURFACE,
  UI_COLOR_ICON_GRAY,
  UI_COLOR_SURFACE_INFO,
  UI_COLOR_TEXT_SUBTITLE
} from '../../../../constants/uiColors'

const RefundScanEmptyProduct = ({ manualError }) => (
  <Box
    sx={{
      minHeight: 96,
      px: 2,
      py: 1.5,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      color: manualError ? UI_COLOR_DANGER_OUTLINE : UI_COLOR_TEXT_SUBTITLE,
      border: `1px solid ${manualError ? UI_COLOR_DANGER_OUTLINE : UI_COLOR_BORDER_INFO_SOFT}`,
      backgroundColor: manualError ? UI_COLOR_DANGER_SURFACE : UI_COLOR_SURFACE_INFO,
      borderRadius: 2
    }}
  >
    <GoogleIcon
      name={manualError ? 'scan' : 'package_2'}
      size={24}
      color={manualError ? UI_COLOR_DANGER_OUTLINE : UI_COLOR_ICON_GRAY}
    />
    {manualError ? (
      <Typography sx={{ fontSize: 13, fontWeight: 700, mt: 0.75 }}>
        {REFUND_APPROVAL_TEXT.productNotFoundTitle}
      </Typography>
    ) : (
      <Typography sx={{ fontSize: 13, mt: 1 }}>{REFUND_APPROVAL_TEXT.productWillAppear}</Typography>
    )}
  </Box>
)

export default RefundScanEmptyProduct
